<template>
  <!--begin::Mixed Widget 1-->
  <div class="card card-custom bg-gray-100 card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 bg-danger py-6">
      <h3 class="card-title font-weight-bolder text-white">
        Daftar Siswa Tertunda
      </h3>
      <div class="card-toolbar">
        <b-input
          type="text"
          ref="searchbox"
          placeholder="Search"
          class="d-inline mx-5"
          style="width:150px"
        />
        <b-button>Reload</b-button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-3 pb-0">
      <!--begin::Table-->

      <b-modal
        id="modal-1"
        ref="my-modal"
        hide-footer
        title="Buka Penunda Siswa"
      >
        <p class="">
          Anda yakin akan membuka penunda {{ selectedSiswa.nama }} ?<br />
          Masukkan Kode Guru BK
        </p>
        <b-input v-model="code" placeholder="Kode Guru BK"></b-input>
        <div style="display:flex">
          <b-button
            class="mt-3 mx-4"
            variant="outline-info"
            block
            @click="hideModal"
            >Batal</b-button
          >
          <b-button
            class="mt-3 mx-4"
            variant="outline-success"
            block
            @click="aksiBatal"
            >Oke Batalkan</b-button
          >
        </div>
      </b-modal>
      <div class="table-responsive">
        <table class="table table-borderless table-vertical-center">
          <thead>
            <tr>
              <th class="p-0" style="width: 40px"></th>
              <th class="p-0" style="min-width: 150px"></th>
              <th class="p-0" style="min-width: 100px"></th>
              <th class="p-0" style="min-width: 125px"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in dataSiswa">
              <tr v-bind:key="i">
                <td class="pl-0">
                  {{ i + 1 }}
                </td>
                <td class="pl-0">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >
                    {{ item.nama }}
                  </a>
                  <div>
                    <span class="">NIS: {{ item.nis }} </span>
                    <span class="text-success" v-if="item.logins.length > 0"
                      >(Sudah Login)</span
                    >
                    <span
                      class="text-success"
                      v-if="item.downloadRapotLog.length > 0"
                      >(Sudah Download)</span
                    >
                    <span class="text-warning" v-if="item.logins.length == 0"
                      >(Belum Login)</span
                    >
                  </div>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                    Kelas {{ item.kelas.label }}
                  </span>
                </td>
                <td class="text-right">
                  <b-button
                    v-b-modal.modal-1
                    class="btn btn-light btn-sm"
                    @click="bukaPenunda(item)"
                    ><span class="svg-icon svg-icon-md svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/General/Settings-1.svg"
                      ></inline-svg>
                      <!--end::Svg Icon-->
                    </span>
                    <span class="d-block">Buka Penunda</span></b-button
                  >
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Mixed Widget 1-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "daftartertunda",
  components: {},
  props: ["dataSiswa"],
  data() {
    return {
      strokeColor: "#D13647",
      chartOptions: {},
      series: [
        {
          name: "Net Profit",
          data: [30, 45, 32, 70, 40, 40, 40]
        }
      ],
      selectedSiswa: {},
      apiURL: "https://localhost:3001/guru",
      code: ""
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  methods: {
    bukaPenunda(item) {
      this.selectedSiswa = item;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    aksiBatal() {
      this.hideModal();
      return axios
        .post(this.apiURL + "/bukatunda", {
          code: this.code,
          studentid: this.selectedSiswa._id
        })
        .then(response => {
          if (response.status == 200) {
            alert("Buka tunda berhasil");
            window.location.reload();
          }
        })
        .catch(e => {
          alert("Maaf, Buka tunda gagal", e);
        });
    }
  }
};
</script>
